/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsroomguestsweeklyexplain4Inputs */

const en_statsroomguestsweeklyexplain4 = /** @type {(inputs: Statsroomguestsweeklyexplain4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each guest counts in the week they were first in a Live Room.`)
};

const de_statsroomguestsweeklyexplain4 = /** @type {(inputs: Statsroomguestsweeklyexplain4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeder Gast zählt in der Woche, in der er zum ersten Mal in einem Live Room war.`)
};

/**
* | output |
* | --- |
* | "Each guest counts in the week they were first in a Live Room." |
*
* @param {Statsroomguestsweeklyexplain4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsroomguestsweeklyexplain4 = /** @type {((inputs?: Statsroomguestsweeklyexplain4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsroomguestsweeklyexplain4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsroomguestsweeklyexplain4(inputs)
	return de_statsroomguestsweeklyexplain4(inputs)
});
export { statsroomguestsweeklyexplain4 as "statsRoomGuestsWeeklyExplain" }